import React, { createContext, useContext, useEffect, useState } from 'react'

import { useOrg } from 'contexts/OrgContext'

export const FiltersContext = createContext()

export function useFilters() {
  return useContext(FiltersContext)
}

export const ruleFilterStateDisplayLabels = {
  dateRange: 'Date Range',
  usdRange: 'USD Amount',
  category: 'Category',
  type: 'Type',
  source: 'Source',
  sourceType: 'Source Type',
  token: 'Token',
  memo: 'Memo',
  function: 'Function',
  from: 'From',
  to: 'To',
  wallet: 'Wallet',
  pricing_method: 'Pricing Method',
}

export const filterStateDisplayLabels = {
  ...ruleFilterStateDisplayLabels,
  syncStatus: 'Sync Status',
  transactionId: 'Transaction ID',
  isMissingPrice: 'Missing Price',
}

export const defaultFilterState = {
  dateRange: [null, null],
  usdRange: [null, null],
  category: [],
  type: [],
  source: [],
  sourceType: [],
  token: [],
  memo: '',
  function: [],
  from: [],
  to: [],
  txn_id: [],
  wallet: [],
  assetType: [],
  syncStatus: [],
}

export function FiltersProvider({ children }) {
  const [filters, setFilters] = useState([])
  const [filterState, setFilterState] = useState(defaultFilterState)
  const { org } = useOrg()

  const value = {
    filters,
    filterState,
    defaultFilterState,
  }

  useEffect(() => {
    setFilterState(defaultFilterState)
    setFilters([])
  }, [org])

  return <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>
}
